module.exports = __webpack_public_path__ + "img/doble-clasica-1.d845ba75.jpg";